import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            常见问答
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            关于天美影视，你想知道的都在这里
          </h2>
          <p className="text-sm text-foreground-500">
            快速了解天美影视的观看方式、资源覆盖和平台特点
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqData.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
              open={faq.id === 1}
            >
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 md:py-5 cursor-pointer list-none select-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-600 transition-transform group-open:rotate-180 text-sm"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}